module.exports = __webpack_public_path__ + "img/01-8.a4cab526.png";